import { TypographyOptions } from '@material-ui/core/styles/createTypography';

export const typography: TypographyOptions = {
  fontFamily: 'Poppins',
  fontSize: 16,
  h1: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontSize: 68,
  },
  h2: {
    fontFamily: 'Poppins',
    fontWeight: 700,
    fontSize: 28,
    color: '#F15A24',
  },
  h3: {
    fontFamily: 'Poppins',
    fontWeight: 700,
    fontSize: 20,
    color: '#F15A24',
  },
  h4: {
    fontFamily: 'Poppins',
    fontSize: '18px',
    lineHeight: '27px',
    fontWeight: 700,
  },
  h5: {
    fontFamily: 'Poppins',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 700,
  },
  body1: {
    fontSize: 15,
    lineHeight: 1.8,
  },
  body2: {
    fontSize: '14px',
    lineHeight: '18.2px',
  },
  button: {
    fontFamily: 'Poppins',
    fontSize: 16,
    lineHeight: 1.8,
    textTransform: 'uppercase',
  },
  subtitle2: {
    color: '#b6b6b6',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    letterSpacing: 0,
    textAlign: 'left',
  },
};
